import { render } from "./page-visi-misi.vue?vue&type=template&id=169c00e2&scoped=true"
import script from "./page-visi-misi.vue?vue&type=script&lang=js"
export * from "./page-visi-misi.vue?vue&type=script&lang=js"

import "./page-visi-misi.vue?vue&type=style&index=0&id=169c00e2&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-169c00e2"]])

export default __exports__